// REACT
import React from "react";

// MATERIAL-UI

// COMPONENTS
import Body from "./body";
import Container from "src/components/common/Container";

// ASSETS
import { DetailsProps } from "./types";
import Header from "./header";

const config = {
  borderRadius: "20px",
};

const Details = (props: DetailsProps) => {
  return (
    <Container config={config}>
      {props.header.heading === "My details" ? (
        <Header heading={props.header.heading} />
      ) : (
        <Header heading={props.header.heading} picture={props.header.picture} />
      )}
      <Body data={props.body} isUser={props.isUser} />
    </Container>
  );
};

export default Details;
